import { render } from "./App.vue?vue&type=template&id=dd89d0ba"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=dd89d0ba&lang=css"

import exportComponent from "/Users/chenjun/Desktop/myProject/pbl-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__